import SessionsComponent from "../components/sessions/SessionsComponent";

export default function SessionsPage() {
  return <SessionsComponent />;
}
